module.exports = __webpack_public_path__ + "img/banner.298f48e9.jpg";